export default __webpack_public_path__ + "static/media/404.45ede9c6.png";